import { ArticleCardSkeleton } from '@xing-com/crate-lebenslauf-components';
import { SkeletonBody } from '@xing-com/skeleton';
import { scale360, spaceL } from '@xing-com/tokens';

import {
  StyledHeroSkeleton,
  StyledDescriptionSkeleton,
  StyledArticlesHeadlineSkeleton,
  StyledArticlesDescriptionSkeleton,
} from './article-skeleton.styled';
import { StyledDivider, StyledCarousel } from './article.styled';

export const ArticleSkeleton: React.FC = () => (
  <>
    <StyledHeroSkeleton size="large" data-qa="lebenslauf-article-loading" />
    <StyledDescriptionSkeleton amountRows={3} />

    <StyledArticlesHeadlineSkeleton amountRows={1} />
    <StyledArticlesDescriptionSkeleton amountRows={1} />
    <StyledCarousel
      itemMaxWidth={scale360}
      itemMinWidth={scale360}
      itemSpacing={spaceL}
      itemSpacingConfined={spaceL}
      itemSnapPosition="center"
    >
      {Array.from(Array(5).keys()).map((id) => (
        <ArticleCardSkeleton key={id} />
      ))}
    </StyledCarousel>

    <StyledDivider />

    <StyledDescriptionSkeleton amountRows={4} />
    <StyledDescriptionSkeleton amountRows={2} />
    <SkeletonBody amountRows={4} />
  </>
);
